import { useHomeActivityQuery } from 'generated/graphql';
import { useLoading } from 'modules';



export function useHomeActivity() {
  const tuple = useHomeActivityQuery({});
  const loading = useLoading([tuple]);

  return {
    loading,
    data: {
      firstName: tuple.data?.loggedInUser?.firstName ?? '',
      lastName: tuple.data?.loggedInUser?.lastName ?? '',
      email: tuple.data?.loggedInUser?.email ?? ''
    }
  };
}
